export const CONTRACT_STATUSES = {
  key: {
    EMPTY: "Empty",
    SUBMITTED: "Submitted",
    CONFIRMED: "Confirmed",
    SHIPPED: "Shipped",
    SIGNED: "Signed"
  },
  value: {
    EMPTY: "empty",
    SUBMITTED: "submitted",
    CONFIRMED: "confirmed",
    SHIPPED: "shipped",
    SIGNED: "signed"
  }
};
